import { parseISO, isValid as isDateValid } from 'date-fns';
import {
    UserChanges,
    ValueKey,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/helpers/types';

type ValidationResult = [boolean, string[], boolean];

export const VALUE_KEY: ValueKey = 'value';
export const DATE_KEY: ValueKey = 'date';

export const validateUserChanges = (
    userChanges: UserChanges,
): ValidationResult => {
    const invalidKeys: string[] = [];

    const allDefined = !Object.values(userChanges).some(
        (valueObj) => valueObj === undefined || valueObj.value === undefined,
    );

    const isValid = Object.entries(userChanges).every(([key, valueObj]) => {
        if (!valueObj || valueObj.value === undefined) {
            invalidKeys.push(key);
            return false;
        }

        // Validate Date.
        if (valueObj?.date !== undefined) {
            if (!isDateValid(parseISO(valueObj.date))) {
                return false;
            }
        }

        if (typeof valueObj.value === 'number') {
            return !Number.isNaN(valueObj.value);
        }

        if (typeof valueObj.value === 'string') {
            return !Number.isNaN(Date.parse(valueObj.value));
        }

        return false;
    });

    return [isValid, invalidKeys, allDefined];
};
